import { ensureProtocol } from './ensureProtocol';
import { normalizeMeUrlDomain } from './appConfig';

export function isMeUrlHostname(hostname: string, meUrls: string[]): boolean {
  if (!meUrls.length) {
    return false;
  }

  const host = normalizeMeUrlDomain(hostname);

  return meUrls.some((domain) => host === domain || host.endsWith(`.${domain}`));
}

export function isInternalMeLink(url: string, meUrls?: string[]): boolean {
  if (!meUrls?.length) {
    return false;
  }

  const urlWithProtocol = ensureProtocol(url);
  if (!urlWithProtocol) {
    return false;
  }

  try {
    const { hostname } = new URL(urlWithProtocol);
    return isMeUrlHostname(hostname, meUrls);
  } catch {
    return false;
  }
}
